






















































































































import { Component, Prop, Vue } from "vue-property-decorator";
//import Vue from 'vue'
//import VueYoutube from 'vue-youtube'

//Vue.use(VueYoutube)
interface Album {
  title: string;
  items: Array<Item>;
  comments: Array<Comment>;
}
interface Item {
  id: string;
  title: string;
}
interface Comment {
  id: string;
  title: string;
  items: Array<string>;
  urls: Array<Url>;
}
interface Url {
  url: string;
  title: string;
}

@Component
export default class SmartHomeWorld extends Vue {
  @Prop()
  private msg!: string;
  albumIndex = 0;
  albumTitle = 'ワルツ';
  videoIndex = 0;
  videoTitle = '01 いきいきストレッチング';

  videoId = '5IlfzLYadNk';

  album1:Album = {
    title: '空間知能化の概要',
    items: [{id: 'zdBq4ynqnRM', title: 'Programming your home automation with the Google Assistant (Behind the Actions, Ep. 3)'},
            {id: 'Of0JiCAE6Eg', title: 'Integrating Smart Devices With the Google Assistant and Google Cloud IoT (Cloud Next 2019)'},
            {id: '10Nelw2nL-Q', title: 'Building IoT Applications With Cloud IoT and Firebase (Cloud Next 2019)'},
           ],
    comments:[
      { id: '1',
        title:'1.空間知能化の概要',
        items: ['空間知能化とは、様々なセンサーを用いて空間内の事象を捉え、ネットワーク化されたコンピュータや家電品が、 これらの情報を知的に利用することにより、人間に適切なサービスを提供する機能を空間（システム）が持つ事です。',
               '部分的な知能を持つコンピュータや家電品は、ネットワークで相互接続されることで、空間（システム）との相互作用で、より知性的になります。',
               '空間知能化を構成するネットワーク化されたコンピュータや家電品は、分散知能化ネットワークデバイス（DIND：Distributed Intelligent Networked Device）と呼ばれます。',
               'DINDは、主にカメラやマイクロフォンと言うセンシング機能を有し、知能化された空間内の情報を処理します。',
               '知能化された空間は、人間に対して物理的・心理的なサポートを与えることが可能になり、人間に満足感を提供することができます。',
               'DINDに加えて、分散知能化ネットワークセンサー（DIND：Distributed Intelligent Networked Sensore）と呼ばれるセンサー機器が、DINDの補助的な役割を行います。',
               ],
        urls:[{url: 'https://developers.google.com/assistant/smarthome/overview', title: 'Google Assistant Docs: Smart Home'},
              {url: 'https://medium.com/google-developers/jdanielmyers-smart-home-eac8f87fd56e', title: 'Google Assistant Smart Home Part 2: API Implementation'}], 
      },
      { id: '2',
        title:'空間知能化の構成要素',
        items: ['空間知能化では、Googleの「Actions on Google Smart Home」を利用するため。以下の構成要素(DIND)を使用します。',
               '①「Androidタブレット」：②～⑤の機器の設定を行うために使用する',
               '②「Chromecast Ultra(Android TV内蔵)」：液晶テレビの裏に設置する。',
               '③「Google Nest Hub Max」：居間に設置する。',
               '④「Google Nest Mini」：洗面所やトイレに設置する。',
               '⑤「Google Nest対応の家電製品」：照明器具など。',
               ],
        urls:[{url: 'https://developers.google.com/assistant/smarthome/overview', title: 'Actions on Google Smart Homeー'},
              {url: 'https://developers-jp.googleblog.com/2019/07/local-home-sdk-dp.html', title: 'Local Home SDK デベロッパー プレビュー'}], 
      },
      { id: '3',
        title:'3.空間知能化の機能',
        items: ['空間知能化では、以下のような機能を有しています。',
               '①「Androidタブレット」：②～⑤の機器の設定を行うために使用する',
               '②「Chromecast Ultra(Android TV内蔵)」：液晶テレビの裏に設置する。',
               '③「Google Nest Hub Max」：居間に設置する。',
               '④「Google Nest Mini」：洗面所やトイレに設置する。',
               '⑤「Google Nest対応の家電製品」：照明器具など。',
               ],
        urls:[{url: 'https://qiita.com/ryo-hashioka/items/c25858d10bb8f4234865', title: 'Dialogflow の Java client library は Android で動作するのか？（DetectIntent編）'}], 
      },
      { id: '4',
       title:'4.Local Home APIで空間知能化を実現する方法',
        items: ['Local Home APIは、「Google Nest」機器から、クラウドを経由せず、直接、デバイス（家電製品など）を制御します。（図2を参照）',
               ],
        urls:[{url: 'https://qiita.com/ryo-hashioka/items/c25858d10bb8f4234865', title: 'Dialogflow の Java client library は Android で動作するのか？（DetectIntent編）'}], 
      },
      { id: '5',
        title:'5.Android OSで空間知能化を実現する方法',
        items: ['Android OSで空間知能化を実現するには2つの方法があります。',
               '①Androidタブレットを使用する',
               '②「新型Chromecast Ultra（Android TV）」を使用する',
               'この場合、Androidアプリから、「Dialogflow」をアクセスする必要があります。',
               'Androidアプリから、「Dialogflow」をアクセスするためには「credentials.json」なるファイルをダウンロードする必要があります。',
               ],
        urls:[{url: 'https://qiita.com/ryo-hashioka/items/c25858d10bb8f4234865', title: 'Dialogflow の Java client library は Android で動作するのか？（DetectIntent編）'}], 
      },
      { id: '6',
        title:'6.「credentials.json」ファイルをダウンロードする方法',
        items: ['「Google Cloud」→「Cloud AIM」→「入門ガイド」→「サービス アカウント キーの作成と管理」にアクセスする。',
               'Googleアカウントがある場合、以下の要領でサービス アカウント キーを作成する。',
               '①GCPコンソールにログインする。',
               '②GCPのプロジェクトを選択する。',
               '③GCP サービスアカウントを作成する。',
               '④GCP サービスアカウントキーを作成する。',
               ],
        urls:[{url: 'https://cloud.google.com/iam/docs/creating-managing-service-account-keys?hl=ja#iam-service-account-keys-create-console', title: 'サービス アカウント キーの作成と管理'},
              {url: 'https://www.magellanic-clouds.com/blocks/guide/create-gcp-service-account-key/', title: 'Google Cloud Platform のサービスアカウントキーを作成する'}], 
      },
    ],
  } // end of album_1         
  album2:Album = {
    title: 'Massive IoT',
    items: [{id: 'aaaUSeQGLAA', title: '準備中'},
            {id: 'Y6Ue5hQ9meM', title: '準備中'},
            {id: '5HHJQQhnaqI', title: '準備中'},
           ],
    comments:[{
       id: '1',
       title:'1.Massive IoTとは',
       items: ['近年、無線通信ネットワークといえば、主に大容量のデータを高速に伝送できる4G/5Gなどの携帯電話ネットワークやWi-Fiの進化が注目を集めてきました。',
               'しかし今後は、あらゆるデバイスがネットワークにつながる「Massive IoT」の時代がやってきます。',
               '個々のデータ量は小さくても非常に多くの端末が存在する「モノのインターネット」です。',
               '無線インフラも、これまでとは違う尺度で語られることになります。',
               '「空間知能化」ではMassive IoTとして「Sigfoxネットワーク」を採用します。',
              ],
        urls:[{url: 'https://cdn.clst01.innova-jp.net/kccs-iot/img/pict-sigfox01.png', title: 'SigfoxによるIoTネットワーク'}], 
       },
       {
       id: '2',
       title:'2.Sigfoxネットワーク',
       items: ['Sigfoxネットワークにおいては、基地局とクラウドサービスをSigfox社が提供し、各国のサービスはSigfox社と契約したオペレータが構築運用しています。',
               'Sigfoxはグローバルで統一されたネットワークになるため、開発したIoTソリューションをそのままグローバルに展開可能です。',
               '課金モデルに関しても、自国のオペレータと契約すれば、他国での利用も可能になるといった特長があります。',
              ],
        urls:[{url: 'https://cdn.clst01.innova-jp.net/kccs-iot/img/pict-sigfox01.png', title: 'SigfoxによるIoTネットワーク'}], 
       }
       ],
  }  // end of album_2
  album3:Album = {
    title: 'Google Nest Hub Max',
    items: [
            {id: 'TAfsDXjkD-8', title: '【Google】Nest Hub Maxでスマート家電をコントロール！YouTubeMusicを楽しむのが快適！'},
            {id: 'WkUyyMIBslI', title: '【買ってよかった】Google Nest Hubが便利で楽しい！【開封レビュー】0'},
            {id: 'Yj3CjpGDzAU', title: 'Nest Hub Max in My Smart Home: Face Match, Routines, Gestures, Video Messages'},
            {id: 'Roa3TaNDT6M', title: 'Google Nest Hub Max Full Setup Walk-Through'},
           ],
    comments:[{
      id: '1',
      title:'「Google Nest Hub Max」の概要',
      items: ['「Google Next Hub Max」は、2019年11月22日に日本で発売されたスマートデイスプレイです。',
              'ディスプレイは10型/1,280×800ドットで、7型/1,024×768ドットの無印Nest Hubよりふた周り大きい印象。',
              'Maxの外形寸法は250.1×101.23×182.55mm(幅×奥行き×高さ)、重量は1.32kg。無印の178.5×67.3×118mm/480gよりはかなり大きい。',
              'ただ、奥行きは短めなので、ディスプレイサイズの割には設置しやすいかもしれない。',
           ],
      urls:[], 
    }],
  } // end of album_3
  album4:Album = {
    title: 'Smart Home',
    items: [
            {id: 'hIEIGDsbKqY', title: '5 Smart Home Tech (for Amazon Echo, Google Home & Siri!)'},
            {id: 'X5YQ4o5LzGM', title: 'How to Start a Smart Home in 2020'},
            {id: 'Bc2663p7AHg', title: 'New Smart Home Tour'},
            {id: 'sYqjs8TKkOE', title: 'Keemple Smart Home | 3D animation'},
            {id: 'cpxMsBbzX5A', title: 'Smart Home Tour'},
           ],
    comments:[{
      id: '1',
      title:'スマートホームの歴史',
      items: [
           '日常生活をより便利で快適なものにしたいと思うのは、人間として自然なことです。',
           'スマートホームの事実上の前身である「ホームオートメーション」という分野は、技術の進歩、とくにインターネットとコンピュータを通じて生み出されました。',
           '1950年代のSF小説では、機械によって完全自動で監視され制御された住宅について、初期の構想が描かれています。',
           '1999年のディズニー映画「スマートハウス」は、家庭用コンピュータについての物語で、スマートな機械が自分自身の生命を獲得した結末が描かれています。',
           'この映画の中でディズニーは、住宅のインテリジェント制御ユニットが嫉妬の感情を持つようになるという場面で、図らずも先見の明を示しています。',
           '実際には、幸いなことに、機械が感情を「生み出す」までには、まだ数年かかりそうです。',
           '科学者は、30年以上にわたって、ネットに接続した家電製品とその利用の自動化に取り組んでいます。',
           'しかし、スマートホームという話題が広く一般に関心を持たれるようになったのは、わずか15年前からのことです。',
           'その主な理由は、高齢化社会、環境意識の高まり、持続可能なエネルギー供給に対する期待との関連など、さまざまなトレンドによって現状の課題が生じてきたからです。',
           'デジタル化の進展および自室内での利便性を拡大する新しい手段が出現したこともあって、スマートホームは、2000年前後に、一般的に関心を持たれるようになりました。',
           '2001年にドイツのデュイスブルクに設立された、フラウンホーファーインハウスセンターは、ドイツ語圏諸国におけるモデルプロジェクトです。',
           'このプロジェクトでは、住宅環境のスマートハウス分野において、新しいシステムソリューションや製品の発掘およびテストを実施しています。',
           'ミュンヘンにある「現在の家」では、2005年から2011年まで、中央制御の電子プロセスによるコネクテッドホームを展示していました。',
           'ベルリンのドイツテレコムによる最初のT-Comハウスは、2005年に公開され、見学者の注目を集めました。',
           'このモデルプロジェクトは、さまざまな家電製品をネットに接続して、さまざまな入力機器によって操作することに重点を置いていました。',
           ],
      urls:[{url: 'https://www.youtube.com/watch?v=aaaUSeQGLAA', title: 'Local Home SDK 入門'},
            {url: 'https://www.magellanic-clouds.com/blocks/guide/create-gcp-service-account-key/', title: 'Google Cloud Platform のサービスアカウントキーを作成する'}], 
    }],
  } // end of album_4
  album5:Album = {
    title: '家電制御の概要',
    items: [{id: 'N2S_pwdNmUo', title: 'グーグルホームで照明をつけよう！スマートホーム化計画No.5'},
            {id: 'EX8lkiXax_s', title: 'Google Home Miniがきた！我が家のスマートホーム化への道'},
            {id: 'WZZkjqXS4Jk', title: 'エアコンを声で制御 Google Home でホームオートメーション'},
            {id: 'NCMEpxCFgq8', title: 'お家の家電をスマート化5'},
            {id: 'hmkCxuqfsYA', title: '壁付けランプをスマート照明化してみた！tp-link ミニスマートWi-Fiプラグ'},
           ],
    comments:[{
      id: '1',
      title:'Google Nestで家電操作する方法',
      items: ['Google Nestで家電操作するには2つの方法があります。',
           '①Googleアシスタント対応製品を使って音声操作',
           '②スマートリモコン経由で赤外線リモコン家電を音声操作',
           '例えば、音声で照明を操作したい場合、1番の場合「TP-Link Kasa」や「Philips Hue」といった製品を使います。',
           'このような対応製品を操作したい分だけ購入する必要がありますが、Google Homeの設定だけで良いので設定が簡単です。',
           '2番では、今お使いのシーリング照明（リモコン付）をGoogle Homeとシーリング照明の間にスマートリモコンを経由させて音声操作することになります。',
           'この場合、スマートリモコンは複数の照明に対応でき、既設の照明が使えるので導入コストは抑えられますが、設定はひと手間増えます。',
           ],
      urls:[], 
    }],
  }  // end of album_5      
  album6:Album = {
    title: '「Local Home API」の利用',
    items: [{id: 'aaaUSeQGLAA', title: 'Local Home SDK 入門'},
            {id: 'Y6Ue5hQ9meM', title: 'Local Technologies for the Smart Home (Google I/O 2019)'},
            {id: '5HHJQQhnaqI', title: 'Local Home SDK, Cloud Tasks, & Truth 1.0'},
           ],
    comments:[
     {
      id: '1',
      title:'Google Nestで家電操作する方法',
      items: ['Google Nestで家電操作するには2つの方法があります。',
           '①Googleアシスタント対応製品を使って音声操作',
           '②スマートリモコン経由で赤外線リモコン家電を音声操作',
           '例えば、音声で照明を操作したい場合、1番の場合「TP-Link Kasa」や「Philips Hue」といった製品を使います。',
           'このような対応製品を操作したい分だけ購入する必要がありますが、Google Homeの設定だけで良いので設定が簡単です。',
           '2番では、今お使いのシーリング照明（リモコン付）をGoogle Homeとシーリング照明の間にスマートリモコンを経由させて音声操作することになります。',
           'この場合、スマートリモコンは複数の照明に対応でき、既設の照明が使えるので導入コストは抑えられますが、設定はひと手間増えます。',
           ],
      urls:[{url: 'https://medium.com/google-developers/jdanielmyers-smart-home-eac8f87fd56e', title: 'Google Assistant Smart Home Part 2: API Implementation'},
            {url: 'https://www.tomsguide.com/best-picks/google-home-compatible-devices', title: 'The best Google Home compatible devices in 2020'}], 
    },
    {
      id: '1',
      title:'サンプルアプリ（app-start）の動かし方',
      items: ['Google Nestで家電操作するには2つの方法があります。',
           '①「https://github.com/googlecodelabs/smarthome-local」からモジュールをダウンロードします。',
           '②以下のコマンドを入力して、firebaseプロジェクトを設定します。',
           '# cd smarthome-loca/app-start',
           '# firebase use <project-id>',
           '③以下のコマンドを入力して、npmで依存ライブラリを取得します。',
           '# cd functions',
           '# npm install',
           '③以下のコマンドを入力して、firebaseプロジェクトをデプロイします。',
           '# cd smarthome-loca/app-start',
           '# firebase deploy',
           ],
      urls:[{url: 'https://vstone.co.jp/robotshop/blog/archives/894', title: 'Nest MiniでLocal Home SDKを使ってお家のIoTロボットを操作する 第2回'},
            {url: 'https://codelabs.developers.google.com/codelabs/smarthome-washer-ja/', title: 'スマートホーム洗濯機'}], 
    }],
  }  // end of album_6
  album7:Album = {
    title: '「Interactive Canvas」アプリの作り方',
    items: [{id: 'aaaUSeQGLAA', title: 'Local Home SDK 入門'},
            {id: 'Y6Ue5hQ9meM', title: 'Local Technologies for the Smart Home (Google I/O 2019)'},
            {id: '5HHJQQhnaqI', title: 'Local Home SDK, Cloud Tasks, & Truth 1.0'},
           ],
    comments:[{
       id: '1',
       title:'1.「Interactive Canvas」アプリとは何か',
       items: ['2019年の Google I/O にて発表された Google アシスタント関連の発表の中で、スマートディスプレイへの対応はかなり大きく取り上げられていました。',
               'そして、スマートディスプレイの特徴でもある「画面」を活用したアクションを開発するために、Interactive Canvas という仕組みが導入されています。',
               'これにより、アクションがスマートディスプレイ向けにウェブアプリを提供することができます。',
               '「Interactive Canvas」アプリは、以下のクラウド上で動くアプリとスマートディスプレイ上で動くアプリで構成されます。',
               '①クラウド（DialogFlow/firebase）上で動く「firebase」アプリ',
               '②スマートディスプレイ上で動く「Jue.js」アプリ（JavaScriptアプリ）',
              ],
        urls:[{url: 'https://developers.google.com/assistant/interactivecanvas/', title: 'Interactive Canvas Overview'},
              {url: 'https://qiita.com/h-takauma/items/1425abe44a050dfb3269', title: 'Google Nest Hubの画面対応方法'}], 
       },
       {
       id: '2',
       title:'2.「firebase」と「Jue.js」を使用して「Interactive Canvas」アプリを作る方法',
       items: ['①「Jue.js」を使用して以下の二つのコンポーネントを「/my-name/vue_cli/smart-home/上」に作成します。',
               'components/PlayMusic.vue',
               'components/GotoTest.vue',
               '② 以下のバッチファイル（test.ps1）を実行します。',
               'cd /my-name/vue_cli/smart-home',
               'npm run build',
               'echo "end: npm run build"',
               'rm /my-name/smart_home/dist -Recurse',
               'cp ./dist /my-name/smart_home/ -Recurse -Force',
               'echo "./dist /my-name/smart_home/ -Recurse -Force"',
               'cd /my-name/smart_home',
               'firebase deploy --only hosting',
               'echo "end firebase deploy --only hosting"',
               'cd /my-name/vue_cli/smart-home',
               '③スマートディスプレイで 「OK, Google ダンスの練習につないで」と喋ります。',
               '①で作成した「Jue.js」画面が表示されます。',
              ],
        urls:[], 
       }
       ],
  }  // end of album_7
  album8:Album = {
    title: 'SAPの作り方',
    items: [{id: 'aaaUSeQGLAA', title: 'Local Home SDK 入門'},
            {id: 'Y6Ue5hQ9meM', title: 'Local Technologies for the Smart Home (Google I/O 2019)'},
            {id: '5HHJQQhnaqI', title: 'Local Home SDK, Cloud Tasks, & Truth 1.0'},
           ],
    comments:[{
       id: '1',
       title:'1.SPA（Single Page Application）を作るには',
       items: ['①「npm」：「Jue.js」で作成されたソースを埔里プロセッサ処理をします。',
               '②「Jue.js」：Webブラウザ上で動くSPAアプリのフレームワークになります。',
              ],
        urls:[], 
       },
       {
       id: '2',
       title:'2.「npm」と「Jue.js」を使用してSPA（Single Page Application）を作る方法',
       items: ['①「localhost:8081」でPC上で試験をします。',
               '# cd home-page',
               '# npm run serve',
               '② Webサーバ（apaheなど）に登録するモジュールを生成します。',
               '# cd home-page',
               '# npm run build',
               '③ WinSCPを使用してWebサーバ（apacheなど）に登録します。',
               '「# npm run build」で生成された「dist」ディレクトリの内容をWebサーバ（apacheなど）のroot部分に登録します。',
              ],
        urls:[], 
       }
       ],
  }  // end of album_8

  albums: Array<Album>;

  created () {
    this.albums = [this.album1, this.album2, this.album3, this.album4, this.album5, this.album6, this.album7, this.album8];
    this.firstVideo();
  }
  selectAlbum(index:number) {
    window.console.log("selectAlbum() 1.index: " + index);
    this.albumIndex = index;
    this.firstVideo();
  }
  previousVideo() {
    window.console.log("previousVideo() 1.this.albumIndex: " + this.albumIndex);
    this.videoIndex --;
    if (this.videoIndex < 0) {
      this.videoIndex = this.albums[this.albumIndex].items.length - 1;
    }
    this.videoId = this.albums[this.albumIndex].items[this.videoIndex].id;
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title;
    this.albumTitle = this.albums[this.albumIndex].title;
  }
  firstVideo() {
    window.console.log("firstVideo() 1.this.albumIndex: " + this.albumIndex);
    this.videoIndex = 0;
    this.videoId = this.albums[this.albumIndex].items[this.videoIndex].id;
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title;
    this.albumTitle = this.albums[this.albumIndex].title;
  }
  nextVideo() {
    window.console.log("nextVideo() 1.this.albumIndex: " + this.albumIndex);
    this.videoIndex ++;
    if (this.videoIndex > this.albums[this.albumIndex].items.length - 1) {
      this.videoIndex = 0;
    }
    this.videoId = this.albums[this.albumIndex].items[this.videoIndex].id;
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title;
    this.albumTitle = this.albums[this.albumIndex].title;
    window.console.log("nextVideo() 2.videoId: " + this.videoId);
  }
  selectVideo(index:number) {
    window.console.log("selectVideo() 1.index: " + index);
    this.videoIndex = index;
    this.videoId = this.albums[this.albumIndex].items[this.videoIndex].id;
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title;
    this.albumTitle = this.albums[this.albumIndex].title;
   }

}

